<template>
  <DxPopup
    id="popupMassiveActionDosageProduct"
    :visible="true"
    :drag-enabled="false"
    :show-title="true"
    :show-close-button="true"
    :hide-on-outside-click="false"
    title="Acción masiva sobre producto"
    height="auto"
    @hiding="closeMassiveAction()"
  >
    <div class="popup-massive-action-dosage-product">
      <div class="popup-massive-action-dosage-product__body">
        <div
          v-if="!isIrrigationMasiveAction"
          class="popup-massive-action-dosage-product__inputs"
        >
          <!-- Input dosis -->
          <div class="popup-massive-action-dosage-product__inputs__item-group">
            <label for="dosis">Dosis</label>
            <input
              :class="{
                disabled: disabledDosisInput,
              }"
              type="text"
              v-model="localData.dosis"
              :disabled="disabledDosisInput"
              id="dosis"
              min="0"
              :max="99999.9"
              pattern="^\d{1,5}([.,]\d)?$"
              @input="validateDosis"
            />
          </div>
          <!-- Input totales -->
          <div
            class="popup-massive-action-dosage-product__inputs__item-group"
            v-if="showTotals"
          >
            <label for="totales">Totales</label>
            <input
              :class="{
                disabled: disabledTotalesInput,
              }"
              type="text"
              v-model="localData.totales"
              :disabled="disabledTotalesInput"
              id="totales"
              min="0"
              :max="99999.9"
              pattern="^\d{1,7}([.,]\d)?$"
              @input="validateTotales"
            />
          </div>
          <!-- Input sectores -->
          <div
            class="popup-massive-action-dosage-product__inputs__item-group"
            v-if="showSectorDetails"
          >
            <label for="sectores">Sectores</label>
            <DxDropDownBox
              id="sectores"
              :value="localData.sectores"
              valueExpr="id"
              displayExpr="name"
              :dataSource="sectoresOptions"
              :opened.sync="sectoresDropdownOpen"
              style="width: 100%"
              :showClearButton="false"
            >
              <template #content>
                <DxList
                  :dataSource="sectoresOptions"
                  selectionMode="multiple"
                  :selectedItemKeys="localData.sectores"
                  :showNextButton="false"
                  @itemClick="onSectoresItemClick"
                  keyExpr="id"
                  displayExpr="name"
                  style="max-height: 150px"
                >
                  <template #item="{ data }">
                    <div
                      :class="{
                        'sector-item': true,
                        'sector-item--selected': localData.sectores.includes(
                          data.id
                        ),
                      }"
                    >
                      {{ data.name }}
                    </div>
                  </template>
                </DxList>
              </template>
            </DxDropDownBox>
          </div>
        </div>
        <div v-else class="popup-massive-action-dosage-product__inputs">
          <!-- Input Tiempo de riego -->
          <div class="popup-massive-action-dosage-product__inputs__item-group">
            <label for="irrigation">Tiempo de riego (hh:mm)</label>
            <input
              type="text"
              v-model="localData.irrigation"
              id="irrigation"
              @keypress="onlyNumbersAndColon"
            />
          </div>
        </div>
        <!-- Calendario seleccionable -->
        <div class="popup-massive-action-dosage-product__form-group">
          <Calendar
            :multiselect="true"
            :initialDate="initValueCalendar"
            :activeStart="initValueCalendar"
            :activeEnd="endValueCalendar"
            @update:selectedDates="selectedDates = $event"
            :calendarType="calendarType"
          />
        </div>
      </div>
      <div class="popup-massive-action-dosage-product__footer">
        <div class="popup-massive-action-dosage-product__footer__content">
          <button class="standard-blue-btn" @click="saveData">Guardar</button>
        </div>
      </div>
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup, DxDropDownBox, DxList } from "devextreme-vue";
import Calendar from "../../Calendar/Calendar.vue";

export default {
  name: "PopupMassiveActionDosageProduct",
  components: {
    DxPopup,
    DxDropDownBox,
    DxList,
    Calendar,
  },
  props: {
    showTotals: { default: false },
    showSectorDetails: { default: false },
    massiveActionProduct: { default: () => ({}) },
    calendarOptions: { default: null },
    initValue: { default: () => new Date() },
    endValue: { default: () => new Date() },
    temporalFrame: { default: "DIARIO" },
    isIrrigationMasiveAction: { default: false },
  },
  computed: {
    initValueCalendar() {
      return new Date(this.initValue);
    },
    endValueCalendar() {
      return new Date(this.endValue);
    },
    calendarType() {
      switch (this.temporalFrame) {
        case "DIARIO":
          return "day";
        case "SEMANAL":
          return "week";
        case "MENSUAL":
          return "month";
        default:
          return "day";
      }
    },
    disabledDosisInput() {
      return (
        this.localData.totales !== null &&
        this.localData.totales !== "" &&
        this.localData.totales !== undefined
      );
    },
    disabledTotalesInput() {
      return (
        this.localData.dosis !== null &&
        this.localData.dosis !== "" &&
        this.localData.dosis !== undefined
      );
    },
  },
  data() {
    return {
      localData: {
        index: this.massiveActionProduct?.index ?? null,
        dosis: this.massiveActionProduct?.dosis ?? null,
        totales: this.massiveActionProduct?.totales ?? null,
        sectores: Array.isArray(this.massiveActionProduct?.sectores)
          ? this.massiveActionProduct.sectores
          : [],
        irrigation: this.massiveActionProduct?.irrigation_time ?? null,
      },
      selectedDates: [],
      sectoresDropdownOpen: false,
      sectoresOptions: Array.from({ length: 25 }, (_, i) => ({
        id: i + 1,
        name: String(i + 1),
      })),
    };
  },
  watch: {
    massiveActionProduct: {
      handler(newVal) {
        this.localData = {
          index: newVal?.index ?? null,
          dosis: newVal?.dosis ?? null,
          totales: newVal?.totales ?? null,
          sectores: Array.isArray(newVal?.sectores) ? newVal.sectores : [],
          irrigation: newVal?.irrigation_time ?? null,
        };
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    saveData() {
      if (this.selectedDates.length === 0) {
        this.closeMassiveAction();
        return;
      }
      if (this.isIrrigationMasiveAction) {
        this.validateIrrigationTime();
        this.$emit(
          "saveMassiveIrrigation",
          this.localData.irrigation,
          this.selectedDates
        );
      } else {
        this.$emit(
          "saveMassiveActions",
          { ...this.localData },
          this.selectedDates
        );
      }
    },
    closeMassiveAction() {
      this.$emit("closeMassiveAction");
    },
    onSectoresItemClick(e) {
      const id = e.itemData.id;
      const index = this.localData.sectores.indexOf(id);
      if (index === -1) {
        // Agregar id si no está
        this.localData.sectores.push(id);
      } else {
        // Quitar id si ya está
        this.localData.sectores.splice(index, 1);
      }
      this.localData.sectores.sort((a, b) => a - b);
    },
    validateDosis() {
      let value = String(this.localData.dosis);
      // Permite hasta 5 enteros y 1 decimal
      const match = value.match(/^(\d{0,5})(\.\d?)?/);
      if (match) {
        // Reconstruye el valor permitido
        const newValue = (match[1] || "") + (match[2] || "");
        if (value !== newValue) {
          this.localData.dosis = newValue;
          this.$notifyDX(
            {
              message:
                "El valor máximo permitido es 5 dígitos enteros y 1 decimal.",
              width: 550,
            },
            "warning",
            3000
          );
        }
      }
    },
    validateTotales() {
      let value = String(this.localData.totales);
      // Permite hasta 7 enteros y 1 decimal
      const match = value.match(/^(\d{0,7})(\.\d?)?/);
      if (match) {
        // Reconstruye el valor permitido
        const newValue = (match[1] || "") + (match[2] || "");
        if (value !== newValue) {
          this.localData.totales = newValue;
          this.$notifyDX(
            {
              message:
                "El valor máximo permitido es 7 dígitos enteros y 1 decimal.",
              width: 550,
            },
            "warning",
            3000
          );
        }
      }
    },
    validateIrrigationTime() {
      let value = this.localData.irrigation;
      // Permite formato h:mm donde h es 0-23 y mm es 00-59
      const match = String(value).match(/^(\d{1,2})(:(\d{1,2}))?$/);
      if (match) {
        let hours =
          match[1] === "0" || match[1] === "00"
            ? 0
            : parseInt(match[1].replace(/^0+/, ""), 10);
        let minutes = match[3] ? parseInt(match[3], 10) : 0;

        if (hours > 23) {
          hours = 23;
          minutes = 59;
        }
        if (minutes > 59) minutes = 59;

        // Reconstruye el valor permitido
        const formattedHours = hours;
        const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
        const minutesPart = match[2] ? ":" + formattedMinutes : "";
        let newValue = "";
        if (!minutesPart || minutesPart === ":00") {
          // Si los minutos son 00 y el usuario los ha introducido, mantenlos
          newValue = formattedHours;
        } else {
          // Si hay minutos y no son 00, añádelos formateados
          newValue = formattedHours + minutesPart;
        }
        if (value !== newValue) {
          this.localData.irrigation = newValue;
        }
      } else {
        // Si no coincide con el patrón, limpia el valor
        this.localData.irrigation = "";
      }
    },
    onlyNumbersAndColon(e) {
      const char = e.key;
      const value = e.target.value;

      // Permitir solo números si antes del ":" hay menos de 2 dígitos
      if (/[0-9]/.test(char)) {
        const [beforeColon, afterColon] = value.split(":");
        if (!value.includes(":")) {
          if ((beforeColon?.length ?? 0) < 2) return;
        } else {
          if ((afterColon?.length ?? 0) < 2) return;
        }
      }

      // Permitir ":" solo si aún no existe y hay 1 o 2 números antes
      if (char === ":" && !value.includes(":") && /^[0-9]{1,2}$/.test(value)) {
        return;
      }

      // Bloquear cualquier otro caso
      e.preventDefault();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./popUpMassiveActionDosageProduct.scss";
</style>
